<template>

    <div id="modalPreview" class="modal-custom" :style="isModalVisible" @click.prevent="handleClickOuterContent">

        <span class="modal-custom__close" @click.prevent="$emit('reset-preview-selected')">&times;</span>

        <div class="modal-custom__content" ref="modalContent" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
            <span class="modal-custom__navigation modal-custom__navigation--prev" v-show="shouldShowNavigation" @click="handleClickNavigationArrows(-1)">&#8249;</span>
            <img :src="selectedImagePath" id="img01" alt="">
            <span class="modal-custom__navigation modal-custom__navigation--next" v-show="shouldShowNavigation" @click="handleClickNavigationArrows(1)">&#8250;</span>
        </div>

    </div>

</template>

<script>
export default {
    name: "ImagePreview",
    props: {
        images: {
            required: true,
            type: Array,
            default: () => []
        },
        selectedImage: {
            type: Number,
            default: null
        }
    },

    data(){
        return{
            activeSlide: null,
            touchStartX: null
        }
    },

    computed: {
        shouldShowNavigation(){
            return this.images.length > 1
        },
        lastIndexOfImages(){
          return this.images.length - 1
        },

        isSelected(){
            return typeof this.selectedImage === 'number'
        },

        isModalVisible(){
            return { display: this.isSelected ? 'block' : 'none' }
        },

        selectedImagePath(){
            if( this.activeSlide === null ) return null
            let { path } = this.images[this.activeSlide]
            return `/storage/${path}`
        }

    },

    methods: {

        handleTouchStart(e){
            this.touchStartX = e.touches[0].clientX
        },

        handleTouchMove(e){
           if( ! this.touchStartX ) return

            let touchMove = e.touches[0].clientX

            let xDiff = this.touchStartX - touchMove

            if( Math.abs( xDiff ) ){
                if( xDiff > 0 ) {
                    if(xDiff > 100){
                        this.handleClickNavigationArrows(1)
                        this.touchStartX = null
                    }
                } else {
                    if( xDiff < -100 ){
                        this.handleClickNavigationArrows(-1)
                        this.touchStartX = null
                    }
                }
            }

        },

        handleTouchEnd(){
            this.touchStartX = null
        },

        handleClickOuterContent(e){
            let { target } = e
            if( ! target.closest('.modal-custom__content') ){
                this.$emit('reset-preview-selected')
            }
        },

        handleClickNavigationArrows( next ){
            if( this.activeSlide + next === -1 ) return this.activeSlide = this.lastIndexOfImages
            if( this.activeSlide + next > this.lastIndexOfImages ) return this.activeSlide = 0
            this.activeSlide += next
        }

    },

    watch:{
        selectedImage(v){
            this.activeSlide = this.selectedImage
        }
    }

}
</script>

<style lang="scss" scoped>
@keyframes zoom {
    from {transform:scale(0)}
    to {transform:scale(1)}
}

/* The Modal (background) */
.modal-custom {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 3000; /* Sit on top */
    padding: 100px 0;
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow-y: auto; /* Enable scroll if needed */
    overflow-x: hidden; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.9); /* Black w/ opacity */

    &__navigation{
        position: absolute;
        padding: 30px 20px;
        font-size: 60px;
        color: #fff;
        top: 50%;
        cursor: pointer;
        transform: translateY(-50%);
        transition: opacity .2s ease;

        &:hover{
            opacity: .9;
        }

        &--prev{
            left: -60px;
        }

        &--next{
            right: -60px;
        }

    }

    &__content {
        position: relative;
        margin: 10px auto;
        display: block;
        width: 100%;
        max-width: 768px;
        animation-name: zoom;
        animation-duration: 0.6s;
    }


    &__close {
        position: absolute;
        top: 15px;
        right: 35px;
        color: #f1f1f1;
        font-size: 40px;
        font-weight: bold;
        transition: 0.3s;

        &:hover,
        &:focus {
            color: #bbb;
            text-decoration: none;
            cursor: pointer;
        }

    }

    @media screen and(max-width: 992px) {
        &__navigation{
            color: #aaa;
            opacity: .6;
            &--prev{
                left: 0;
            }

            &--next{
                right: 0;
            }
        }
    }

    @media only screen and (max-width: 768px){
        &__navigation{
            display: none;
        }
    }


}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 768px){
    .modal-custom{
        padding: 50px 10px;
        &__content {
            width: 100%;
        }

        &__close{
            top: 5px;
            right: 15px;
        }

    }
}


</style>
